const LANG_DISPLAY_KEY = 'lang_display';
const LANG_CLIENT_KEY = 'client_lang_display';
const LANGUAGES = {
  JAPAN: 'ja',
  ENGLISH: 'en',
};

const SITES = {
  CMS: 'cms',
  CLIENT: 'client',
};
const DELIVERY_FEE = 770;

const ROLES = {
  STAFF: 'staff',
  HEADQUARTER: 'headquarter',
  SUPER_ADMIN: 'super_admin',
};

export { SITES, LANGUAGES, LANG_DISPLAY_KEY, LANG_CLIENT_KEY, DELIVERY_FEE, ROLES };
